<div class="app-container">
  <page-header [icon]="'far-exchange'" [title]="'product.moves'">
    <ng-container class="header-button">
      <app-exports #exportsModal [entity]="'product-move-packs'" data-cy="exports"></app-exports>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [loading]="areCoreDataLoading()"
      [totalItems]="totalItems()"
      (onSubmit)="applyFilters()"
      (onClearClick)="clearFilters()"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      [filterVisible]="filtersExpanded"
      [allFilters]="filtersForAdvancedVisibility()"
      [defaultFilters]="defaultFilters"
      [advancedFilterKeys]="advancedFilterKeys"
      [isExportButtonShown]="true"
      [entity]="'product-move-packs'"
      [tags]="queryTags.data()"
      (onExportResult)="queryProductMovePacks.refetch()"
    >
      <div class="row">
        <div class="col-sm-4 col-md-2">
          <form-row-input
            [label]="'fulltext'"
            (keydown.enter)="applyFilters()"
            [icon]="null"
            [model]="filters().fulltext"
            (modelChange)="setFilter('fulltext', $event)"
            [dataCyAttribute]="'product-move-pack-fulltext-filter'"
          ></form-row-input>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'stock.load.type' | translate"
            [icon]="null"
            [options]="operationTypes"
            [model]="filters().type"
            (modelChange)="setFilter('type', $event)"
            [dataCyAttribute]="'product-move-pack-type-filter'"
          ></form-row-select>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'depotFrom'"
            [icon]="null"
            [options]="depots()"
            [model]="filters().depotFrom"
            (modelChange)="setFilter('depotFrom', $event)"
            [dataCyAttribute]="'depot-from-filter'"
          ></form-row-select>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-select
            [label]="'depotTo'"
            [icon]="null"
            [options]="depots()"
            [model]="filters().depotTo"
            (modelChange)="setFilter('depotTo', $event)"
            [dataCyAttribute]="'depot-to-filter'"
          ></form-row-select>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-input
            [label]="'date.from'"
            [icon]="null"
            [inputType]="'date'"
            [model]="filters().dateFrom"
            (modelChange)="setFilter('dateFrom', $event)"
          ></form-row-input>
        </div>
        <div class="col-sm-4 col-md-2">
          <form-row-input
            [label]="'date.to'"
            [icon]="null"
            [inputType]="'date'"
            [model]="filters().dateTo"
            (modelChange)="setFilter('dateTo', $event)"
          ></form-row-input>
        </div>
      </div>
      <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
        <div class="row">
          <div class="col-sm-4 col-md-2">
            <form-row-select-multiple
              [label]="'tags'"
              [options]="queryTags.data()"
              [selectedValues]="filters().tags"
              (selectedValuesChange)="setFilter('tags', $event)"
              [isTags]="true"
              [dataCyAttribute]="'tags-filter'"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-select-multiple
              [label]="'tagsNegate'"
              [options]="queryTags.data()"
              [selectedValues]="filters().tagsNegate"
              (selectedValuesChange)="setFilter('tagsNegate', $event)"
              [isTags]="true"
              [dataCyAttribute]="'productMovePacks-tagsNegate-filter'"
            ></form-row-select-multiple>
          </div>
          <div class="col-sm-4 col-md-2">
            <form-row-select
              [label]="'products.checkouts'"
              [icon]="null"
              [options]="checkouts()"
              [model]="filters().checkout"
              (modelChange)="setFilter('checkout', $event)"
              [inputDisabled]="filters().type === 'transfer'"
              [title]="filters().type === 'transfer' ? ('filters.disabled' | translate) : ''"
            ></form-row-select>
          </div>
          <div class="col-sm-4 col-md-2">
            <form-row-select
              [label]="'withOrder'"
              [icon]="null"
              [options]="hasOrderTypes"
              [model]="filters().withOrder"
              (modelChange)="setFilter('withOrder', $event)"
              [inputDisabled]="filters().type === 'transfer'"
              [title]="filters().type === 'transfer' ? ('filters.disabled' | translate) : ''"
            ></form-row-select>
          </div>
          <div class="col-sm-4 col-md-2">
            <form-row-input
              [label]="'orderFulltext.number'"
              (keydown.enter)="applyFilters()"
              [icon]="null"
              [model]="filters().orderFulltext"
              (modelChange)="setFilter('orderFulltext', $event)"
            ></form-row-input>
          </div>
          <div class="col-sm-4 col-md-2">
            <form-row-select
              [label]="'createdBy'"
              [icon]="null"
              [options]="users()"
              [optionKey]="'id'"
              [optionKeyText]="'name'"
              [model]="filters().createdBy"
              (modelChange)="setFilter('createdBy', $event)"
            ></form-row-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-2">
            <form-row-input
              [label]="'operationNumber'"
              [pattern]="'^[0-9]+$'"
              (keydown.enter)="applyFilters()"
              [icon]="null"
              [model]="filters().number"
              (modelChange)="setFilter('number', $event)"
            ></form-row-input>
          </div>
          <div class="col-sm-8 col-md-2">
            <form-row-input
              [label]="'productFulltext'"
              (keydown.enter)="applyFilters()"
              [icon]="null"
              [model]="filters().productFulltext"
              (modelChange)="setFilter('productFulltext', $event)"
            ></form-row-input>
          </div>
          <div class="col-sm-8 col-md-2">
            <form-row-select
              [label]="'supplier'"
              [icon]="null"
              [model]="filters().supplier"
              (modelChange)="setFilter('supplier', $event)"
              [options]="suppliers()"
            ></form-row-select>
          </div>
          <div class="col-sm-8 col-md-2">
            <form-row-select
              [label]="'purpose'"
              [icon]="null"
              [model]="filters().purpose"
              (modelChange)="setFilter('purpose', $event)"
              [options]="purposes()"
            ></form-row-select>
          </div>
        </div>
      </div>
    </app-filter-form>
    <app-base-listing
      [listName]="'productMoves'"
      [query]="queryProductMovePacks"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
